import { render, staticRenderFns } from "./select-school-screen.vue?vue&type=template&id=771282d0&"
import script from "./select-school-screen.vue?vue&type=script&lang=js&"
export * from "./select-school-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports